import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { makeStyles } from '@material-ui/core/styles';
import { Dropdown, Menu, Space, Table, Tag, Modal, Empty, Input, Tooltip, Button as AntButton } from 'antd';
import BrokerService from "../../../services/broker.service";
import { getBrokerList } from "../../../redux/actions/brokerAction";
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { Spinner } from 'react-bootstrap';
import { Base64 } from 'js-base64';
import moment from "moment";
import { saveUserCredentials } from "../../../redux/actions/user";
import StaticPopup from "../../utilities/Static-Popup";
import { Button, Modal as BootstrapModal, CloseButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getLocalStorageObject, setLocalStorageObject } from '../../../util/helper';
import { LogIn, LogOut, Trash2 } from 'lucide-react';
import kiteLogin from "../../../assets/img/login-img/kite-logo.png";
import Alice from "../../../assets/img/login-img/alice.webp";
import Fyers from "../../../assets/img/login-img/Logo-fyers-final.webp";
import ICICI from "../../../assets/img/login-img/icic.webp";
import upstock from "../../../assets/img/login-img/upstock.webp";
import paisa from "../../../assets/img/login-img/5paisa.webp";
import Dhanlog from "../../../assets/img/login-img/dhan.jpg";
import FlatTrade from "../../../assets/img/login-img/flattrade.jpg";
import shoonya from "../../../assets/img/login-img/shoonya-logo.png";
import xts from "../../../assets/img/login-img/xts.png";
import jainam from "../../../assets/img/login-img/jainam.webp"
import kotakNeo from "../../../assets/img/login-img/kotakneo.png";
import firstock from "../../../assets/img/login-img/firstock.png";
import zebu from "../../../assets/img/login-img/zebu.svg";
import AngelBooking from "../../../assets/img/login-img/angel_booking.webp";
import groww from "../../../assets/img/login-img/groww-icon.png"
import arrow from "../../../assets/img/login-img/arrow.svg"
import falconLogo from "../../../assets/img/favicons/android-chrome-512x512.png";
import LoderCom from "../../common/Loder";
import { SAVE_BROKERS_LIST } from "util/actionTypes";
import { getUserBrokerCountAction } from "../../../redux/actions/brokerAction";
import BrokerLimitModal from "./BrokerLimitModal";
import { useToast } from "components/common/custom-toast/Toast";


const customStyles = {
  rows: {
    style: {
      //minHeight: '72px', // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: '8px',
      paddingRight: '8px',
      fontWeight: 'bold',
      background: '#0B90FF',
      color: '#fff'
    },
  },
  cells: {
    style: {
      paddingLeft: '8px',
      paddingRight: '8px',
    },
  },
};

const { confirm } = Modal;

const BrokerAccounts = ({ updateBrokerList, setUpdateBrokerList, setActiveTab, setRefreshBrokers }) => {
  const dispatch = useDispatch();

  const user = useSelector(state => state?.user || {});
  const loginStatus = {
    activeTradeSubscription: user?.activeTradeSubscription || false,
    brokerLoggedIn: user?.brokerLoggedIn || false,
    accounts: user?.accounts ?? 0
  };
  const packageReducer = useSelector(state => state?.packages);

  const [QuikTradeUrl, setQuikTradeUrl] = useState("");
  const [QuikTradePopup, setQuikTradePopup] = useState(false);
  const [copyTokenSuccess, setCopyTokenSuccess] = useState("Copy");
  const brokerList = useSelector(state => state?.brokers?.list || []);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [enablefortradingID, setEnablefortradingID] = useState([]);
  const [shoonyaPwd, setShoonyaPwd] = useState("");
  const [shoonyaTotp, setShoonyaTotp] = useState("");
  const [ShoonyaData, setShoonyaData] = useState("");
  const [copySuccess, setCopySuccess] = useState('Copy URL');
  const [showBrokerLimitModal, setShowBrokerLimitModal] = useState(false);
  const [allowedBrokerCount, setAllowedBrokerCount] = useState(0);
  const [showIpWarningModal, setShowIpWarningModal] = useState(false);
  const [ipWarningModalBroker, setIpWarningModalBroker] = useState(null);
  const toast = useToast()
  const socketJWT = useSelector((state) => state.socketJwt?.data);
  const tradeFeedSource = useSelector((state) => state.tradeFeedSource?.source);
  const [purposeAppliedDict, setPurposeAppliedDict] = useState({});

  useEffect(() => {
    let active = true;
    const fetchPurpose = async () => {
      const pendingBrokers = brokerList.filter(b => b.purpose && purposeAppliedDict[b.id] !== true);
      if (pendingBrokers.length === 0) return;

      for (const b of pendingBrokers) {
        try {
          const res = await BrokerService.getBrokerQuiktrade(b.id);
          if (res?.data?.purposeApplied !== undefined && active) {
            setPurposeAppliedDict(prev => ({ ...prev, [b.id]: res.data.purposeApplied }));
          }
        } catch (e) {
          console.error(e);
        }
      }
    };
    fetchPurpose();
    return () => { active = false; };
  }, [brokerList]);

  useEffect(() => {
    const pendingBrokers = brokerList.filter(b => b.purpose && b.status === "loggedIn" && purposeAppliedDict[b.id] !== true);
    if (!socketJWT || !tradeFeedSource || pendingBrokers.length === 0) return;

    const subscriptions = [];
    pendingBrokers.forEach(b => {
      const channelName = `${socketJWT.wsId}-${b.id}`;
      const sub = tradeFeedSource.subscribe(channelName, (message) => {
        const payload = message?.data;
        if ((payload?.channel === 'brokers') && payload?.broker?.id === b.id) {
          if (payload.broker.purposeApplied === true) {
            setPurposeAppliedDict(prev => ({ ...prev, [b.id]: true }));
          }
        }
      });
      subscriptions.push(sub);
    });

    return () => {
      subscriptions.forEach(sub => {
        try { sub.unsubscribe(); } catch (e) { }
      });
    };
  }, [brokerList, purposeAppliedDict, socketJWT, tradeFeedSource]);

  // Table columns configuration
  const columns = [
    {
      name: 'Broker',
      selector: row => row.type,
      width: 'auto',
      responsive: ['md'],
    },
    {
      name: 'Name',
      selector: row => row.name,
      width: 'auto',
      responsive: ['md'],
    },
    {
      name: 'User Name',
      selector: row => row.userName,
    },
    {
      name: 'Status',
      selector: row => row.status,
      width: 'auto'
    },
    {
      cell: (row, index, column, id) => {

        return (
          row.status === 'loggedIn' ?
            <Button className="btn btn-sm btn-danger"
              onClick={() => handleLogoutBrokerAction(row)}>
              LOG OUT
            </Button>
            : <Button className="btn btn-sm"
              onClick={() => handleLoginBrokerAction(row)}>
              Login
            </Button>
        )

      }
      ,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    },
    {
      cell: (row, index, column, id) => <Button className="btn btn-sm btn-danger"
        onClick={() => handleDeleteBrokerAction(row)}>DELETE</Button>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }

  ];

  const logoByType = {
    zerodha: kiteLogin,
    aliceblue: Alice,
    fyers: Fyers,
    icici: ICICI,
    upstox: upstock,
    "5paisa": paisa,
    angelone: AngelBooking,
    dhan: Dhanlog,
    flattrade: FlatTrade,
    shoonya: shoonya,
    xts: xts,
    kotakneo: kotakNeo,
    firstock: firstock,
    papertrading: falconLogo,
    jainam: jainam,
    zebu: zebu,
    groww: groww,
    arrow: arrow
  };

  const statusMeta = (status) => {
    const normalized = (status || "").toLowerCase();
    if (normalized === "loggedin") return { color: "#198754", text: "Active" }; // bs-success
    if (normalized === "loggedout") return { color: "#fd7e14", text: "Logged out" }; // orange
    if (normalized === "submitted") return { color: "#0dcaf0", text: "Pending" }; // bs-info
    if (normalized === "error") return { color: "#dc3545", text: "Error" }; // bs-danger
    return { color: "#6c757d", text: status || "Unknown" }; // bs-secondary
  };

  const columns2 = [
    {
      title: 'Enable',
      dataIndex: 'enablefortrading',
      key: 'enablefortrading',
      render: (_, row) => {
        return (
          <Tooltip title="Enable for trading">
            <label>
              <input type="checkbox"
                checked={row.quickTrade && row.status === "loggedIn"}
                onClick={(e) => handleEnablefortrading(e, row)}
              />
            </label>
          </Tooltip>
        )

      }
    },
    {
      title: 'Broker',
      dataIndex: 'type',
      key: 'type',
      align: "left",
      responsive: ['md'],
      render: (_, row) => {
        return (
          <div className="d-flex align-items-center">
            {logoByType[row.type] && <img src={logoByType[row.type]} alt={row.type} width="20" height={row.type === "xts" ? "10" : "20"} className="me-1" />}
            <label className="text-start">{row.type === "papertrading" ? "Paper Trade" : row.type} {row.subType ? `(${row.subType})` : ''}</label>
          </div>
        )

      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      align: "left",
      render: (_, row) => {
        return (
          <label className="text-start">{row.name}</label>
        )

      }
    },
    {
      title: 'Broker ID',
      dataIndex: 'userName',
      key: 'userName',
      align: "left",
      render: (_, row) => {
        return (
          <label className="text-start">{row.userName}</label>
        )

      }
    },
    {
      title: 'Purpose',
      dataIndex: 'purpose',
      key: 'purpose',
      align: "left",
      render: (_, row) => {
        if (row.type === "papertrading") {
          return (
            <Tag color="purple" style={{ textTransform: "capitalize", margin: 0 }}>
              Terminal & Algo
            </Tag>
          );
        }
        return (
          <Tag color={row.purpose === 'terminal' ? "blue" : "success"} style={{ textTransform: "capitalize", margin: 0 }}>
            {row.purpose}
          </Tag>
        )
      }
    },
    {
      title: 'Static IP',
      dataIndex: 'ipAddress',
      key: 'ipAddress',
      align: "left",
      render: (_, row) => {
        if ((row.type === 'dhan') && !row.ipId) {
          return <label style={{ fontFamily: "monospace", textAlign: 'left' }}>103.67.236.182</label>;
        }
        return row.ipAddress ? (
          <label style={{ fontFamily: "monospace", textAlign: 'left' }}>{row.ipAddress}</label>
        ) : (
          <Button
            variant="link"
            style={{ fontSize: '13px', textDecoration: 'none', margin: "0px 8px" }}
            onClick={() => setActiveTab && setActiveTab('static-ip')}
          >
            Assign
          </Button>
        )
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: "left",
      render: (_, row) => {
        const meta = statusMeta(row.status);
        return (
          <span className="d-inline-flex align-items-center">
            <span style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: meta.color,
              display: 'inline-block',
              marginRight: 6
            }} />
            <span style={{ fontSize: "13px", whiteSpace: 'nowrap' }}>{meta.text}</span>
          </span>
        )

      }
    },
    {
      title: 'Actions',
      dataIndex: '',
      key: '',
      align: "center",
      render: (_, row) => {
        return (
          <div style={{ display: "flex" }}>
            {row.status === 'loggedIn' ?
              <Button style={{ width: 78, paddingInline: "0.5rem" }} variant="outline-success" className="btn btn-sm  ml-2"
                onClick={() => handleLogoutBrokerAction(row)}>
                <LogOut size={14} /> Logout
              </Button>
              :
              (row.type == "shoonya" || row.type == "xts" || row.type == "kotakneo" || row.type == "angelone" || row.type == "firstock") && (row.collectPasswordForLogin || row.collectTOTPForLogin) ?
                <Button style={{ width: 78, paddingInline: "0.5rem" }} variant="outline-primary" className="btn btn-sm ml-2" onClick={() => getShoonyaPWDtotp(row)}>
                  <LogIn size={14} /> Login
                </Button>
                :
                <Button style={{ width: 78, paddingInline: "0.5rem" }} variant="outline-primary" className="btn btn-sm  ml-2"
                  onClick={() => handleLoginBrokerAction(row)}>
                  <LogIn size={14} /> Login
                </Button>
            }
            <Tooltip title="Delete Account">
              <Button style={{ minWidth: 0, paddingInline: "0.5rem" }} variant="outline-danger" className="btn btn-sm  ml-2"
                onClick={() => handleDeleteBrokerAction(row)}><Trash2 size={14} /></Button>
            </Tooltip>


          </div>
        )

      }
    },

  ];

  useEffect(() => {
    getBrokerList(true);
    setUpdateBrokerList(false);
  }, [updateBrokerList]);

  useEffect(() => {
    if (brokerList.length && brokerList.some(broker => broker.quickTrade && broker.status === "loggedIn")) {
      dispatch(saveUserCredentials({
        ...getLocalStorageObject("user"),
        brokerLoggedIn: true
      }));
    } else {
      dispatch(saveUserCredentials({
        ...getLocalStorageObject("user"),
        brokerLoggedIn: false
      }));
    }
  }, [brokerList, enablefortradingID]);

  useEffect(() => {
    const fetchBrokerCount = async () => {
      const res = await getUserBrokerCountAction();

      if (res?.accounts !== undefined) {
        setAllowedBrokerCount(Number(res.accounts));
      }
    };

    fetchBrokerCount();
  }, []);


  const getShoonyaPWDtotp = async (row) => {
    setShowPopup(true);
    setShoonyaData(row);
  }

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === 'shoonyaPwd') {
      setShoonyaPwd(value);
    } else if (name === 'shoonyaTotp') {
      setShoonyaTotp(value);
    }
  }

  const onSubmit = (e) => {
    e.preventDefault();
    var url = ShoonyaData.manualLoginURL;
    url = url + '&pwd=' + shoonyaPwd + '&totp=' + shoonyaTotp;
    window.location = url;
  }

  const getBrokerList = (isUpate) => {
    setIsLoading(true);
    BrokerService.getBrokers().then(
      response => {

        if (response.code === 200) {
          if (response.data.brokers) {
            const sortedBrokers = response.data.brokers.sort((a, b) => a.type.localeCompare(b.type));
            dispatch({ type: SAVE_BROKERS_LIST, payload: sortedBrokers });
            if (isUpate) {
              setEnablefortradingID(response.data.brokers.filter((item) => item.quickTrade && item.status === "loggedIn").map((item) => item.type));
            }
            var filter = response.data.brokers.filter((item) => item.status === "loggedIn" && item.quickTrade);
            if (filter.length > 0) {
              setLocalStorageObject('user', 'brokerLoggedIn', true, getLocalStorageObject("user"));
            } else {
              setLocalStorageObject('user', 'brokerLoggedIn', false, getLocalStorageObject("user"));
            }

          } else {
            setErrorMessage("No Broker Accounts");
          }
          setIsLoading(false);
        } else {
          toast.error('session expired',);
          setIsLoading(false);
        }
      },
      error => {
        setErrorMessage(
          (error.response && error.response.data) ||
          error.message ||
          error.toString()
        );
        setIsLoading(false);
      }
    );
  }

  const handleDeleteBrokerAction = (broker, event) => {
    confirm({
      title: 'Delete Broker Account',
      icon: null,
      content: `Deleting the broker account "${broker.userName}" will remove all positions and risk monitoring from the system. Are you sure you want to delete this broker account?`,
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        BrokerService.deleteBrokers(broker.id).then(
          response => {
            var successMesage = "Broker Account – " + broker.userName + " Deleted successfully";
            getBrokerList(false);
            toast.success(successMesage);
            setRefreshBrokers(true);
          },
          error => {
            setErrorMessage(
              (error.response && error.response.data) ||
              error.message ||
              error.toString()
            );
            toast.error(error);
          }
        );
      },
    });
  }
  const handleLogoutBrokerAction = (broker, event) => {
    BrokerService.brokerLogout(broker.id).then(
      response => {

        if (broker.quickTrade) {
          updateEablefortradingBroker(broker)
        }

        getBrokerList(false);
        var successMesage = "Broker Account – " + broker.userName + " logged out successfully";
        dispatch(saveUserCredentials({ ...getLocalStorageObject("user"), brokerLoggedIn: false }));
        toast.success(successMesage);
        setEnablefortradingID("");

      },
      error => {
        setErrorMessage(
          (error.response && error.response.data) ||
          error.message ||
          error.toString()
        );
      }
    );
  }
  const handleLoginBrokerAction = async (broker) => {
    window.location = broker.manualLoginURL;
    return;
  };

  const processEnableTrading = (broker) => {
    let checkBoxCount = allowedBrokerCount;

    if (user.activeTradeSubscription && checkBoxCount === 0) {
      checkBoxCount = 1;
    }

    if (enablefortradingID.includes("papertrading")) {
      checkBoxCount += 1;
    }

    if (
      enablefortradingID.length >= checkBoxCount &&
      broker.type !== "papertrading"
    ) {
      setShowBrokerLimitModal(true);
      return;
    }

    if (!enablefortradingID.includes(broker.type)) {
      setEnablefortradingID([...enablefortradingID, broker.type]);
    }

    updateEablefortradingBroker(broker);
  };

  const handleEnablefortrading = async (event, broker) => {
    if (broker.status === "loggedIn") {
      const isChecked = event.target.checked;

      if (!isChecked) {
        setEnablefortradingID(
          enablefortradingID.filter(item => item !== broker.type)
        );
        updateEablefortradingBroker(broker);
        return;
      }

      if (broker.type !== "papertrading" && (!broker.purpose || broker.purpose === "")) {
        toast.error("Please assign a Purpose to this broker before enabling for trading.");
        return;
      }

      if (broker.purpose && purposeAppliedDict[broker.id] !== true) {
        toast.warning("Broker setup is still in progress. Please wait for configuration to complete.");
        return;
      }

      if (broker.type !== "dhan" && broker.type !== "papertrading" && !broker.ipId) {
        setIpWarningModalBroker(broker);
        setShowIpWarningModal(true);
        return;
      }

      processEnableTrading(broker);
    } else {
      toast.info("Please login to the broker before enabling trading.");
    }
  };



  const handleAutoLoginBroker = async (broker, event) => {
    const brokerAddParma = {
      "isDefault": broker.isDefault,
      "autoLogin": (broker.autoLogin) ? false : true,
    };
    BrokerService.updateBroker(broker.id, brokerAddParma).then(
      response => {
        if (response.code === 200) {
          getBrokerList();
          var message = "Auto Login Updated for " + broker.type + "-" + broker.userName;
          toast.success(message);
        } else {
          toast.error('Please try again later',);
        }
      },
      error => {
        setErrorMessage(
          (error.response && error.response.data) ||
          error.message ||
          error.toString()
        );
      }
    );
  }

  const updateEablefortradingBroker = async (broker, event) => {
    const brokerAddParma = {
      "quickTrade": (broker.quickTrade) ? false : true,
    };
    BrokerService.enableBroker(broker.id, brokerAddParma).then(
      response => {
        if (response.code === 200) {
          getBrokerList(false);
          var message = "Enable for trading Updated for " + broker.type + "-" + broker.userName;
          // toast.success(message);
        } else {
          toast.error('Please try again later',);
        }
      },
      error => {
        setErrorMessage(
          (error.response && error.response.data) ||
          error.message ||
          error.toString()
        );
      }
    );
  }

  const copyToClipBoardCall = async (type) => {
    try {
      setCopyTokenSuccess("Copy");
    } catch (err) {
      setCopyTokenSuccess("Failed to copy!");
    }
    setTimeout(() => {
      setCopyTokenSuccess("Copy");
    }, 2000)
  };

  const QuikTradeClick = async (url) => {
    if (!loginStatus?.activeTradeSubscription) {
      setQuikTradePopup(true);
      setQuikTradeUrl(url);
    } else {
      if (brokerList?.filter((item) => item.quickTrade && item.status == "loggedIn")?.length > 0) {
        if (document.location.hostname === 'localhost') {
          var url = `http://localhost:3000`;
        } else if (document.location.hostname === 'beta.fnotrader.com' ||
          document.location.hostname === 'www.beta.fnotrader.com' ||
          document.location.hostname === 'beta-quiktrade.fnotrader.com') {
          var url = `https://beta-quiktrade.fnotrader.com`;
        } else {
          var url = `https://quiktrade.fnotrader.com`;
        }
        window.location = url;
      } else {
        toast.error('Please select an account for QuikTrade',);
      }
    }
  }

  const handleClosePopup = async () => {
    setQuikTradePopup(false);
    setShowPopup(false);
  }
  const ExpandedComponent = ({ data }) => {
    return (
      <>
        <div className="broker-details-wrap">
          <p><label>Auto Login:</label><input type="checkbox" checked={data.autoLogin} readOnly /></p>
          <p><label>API KEY:</label>{data.apiKey}</p>
          <p><label>Secret:</label>{data.secret}</p>
          <p><label>TOTP Secret:</label>{data.totpSecret}</p>
          <p><label>API Token:</label>{data.apiToken}</p>
          <p><label>Token Creation Time:</label>{data.tokenCreationTime}</p>
        </div>
      </>
    );
  };

  var brokerAccountListDataTable = [];
  if (brokerList) {
    brokerAccountListDataTable = brokerList;
  }

  return (
    <div className="broker-accounts-page">
      <div>
        <Col md={12}>
          {isLoading ? (
            <LoderCom size="large" />
            // ) : brokerAccountListDataTable.length === 0 ? (
            //   <Card className="mt-2">
            //     <Card.Body className="text-center">
            //       <h6 className="mb-2">No broker accounts yet</h6>
            //       <p className="mb-3">Connect a broker to start trading.</p>
            //       <Link to="/broker-login" className="btn btn-primary btn-sm">Add Broker</Link>
            //     </Card.Body>
            //   </Card>
            // ) : (:
          ) : (
            <Table rowKey="id" className="holding-table broker-tbl-min"
              locale={{
                emptyText: (
                  <Empty
                    className="mt-3 mb-3"
                    description="No brokers configured"
                  />
                )
              }}
              pagination={false} columns={columns2} dataSource={brokerAccountListDataTable.filter((item) => {
                if (searchTerm === "") {
                  return item;
                } else if (
                  (item.tradingsymbol.toLowerCase().includes(searchTerm.toLowerCase()))
                  || (item.product.toLowerCase().includes(searchTerm.toLowerCase()))
                  || (item.exchange.toLowerCase().includes(searchTerm.toLowerCase()))
                  || (item.quantity == searchTerm)
                ) {
                  return item;
                }
              })}
              rowClassName={(record) => (record.quickTrade && record.status === "loggedIn" ? "enabled-row" : "")}
              expandable={{
                columnWidth: 30,
                expandedRowRender: data => <div className="broker-details-wrap">
                  <p className="d-none xerodha-config-btn text-center"><Link to="/zerodha-config" target="_blank" className="btn btn-sm btn-primary">
                    How to configure Zerodha API step by step
                  </Link></p>
                  {/* {data.autoLogin && <p><label>Auto Login:</label><input type="checkbox" checked={data.autoLogin} readOnly/></p>} */}
                  {data.apiKey && <p><label>API KEY:</label>{data.apiKey.toUpperCase()}</p>}
                  {data.secret && <p><label>Secret:</label>{data.secret.toUpperCase()}</p>}
                  {data.totpSecret && <p><label>TOTP Secret:</label>{data.totpSecret.toUpperCase()}</p>}
                  <p>
                    <label >API Token:</label>
                    <CopyToClipboard text={`${data.apiToken}`} onCopy={() => copyToClipBoardCall(data.type)}>
                      <Button type="Button" className="btn btn-sm btn-primary">{copyTokenSuccess}</Button>
                    </CopyToClipboard>
                  </p>
                  <p><label>Token Creation Time:</label>{moment(data.tokenCreationTime).format("DD-MMM-YYYY HH:MM:SS")}</p>
                  <div className="coptToClipBoard details-section">
                    {data.type == 'zerodha' && (
                      <p><label>Callback URL:</label>
                        <span>https://trade-api.fnotrader.com/v1/callback/zerodha/{data.userName}</span>
                        <CopyToClipboard text={`https://trade-api.fnotrader.com/v1/callback/zerodha/${data.userName}`}>
                          <Button type="Button" className="btn btn-sm btn-primary">{copySuccess}</Button>
                        </CopyToClipboard>
                      </p>
                    )}
                    {data.type == 'zerodha' && (
                      <p><label>Postback URL:</label>
                        <span>https://trader.fnotrader.com/v1/api/zerodha/postback</span>
                        <CopyToClipboard text={`https://trader.fnotrader.com/v1/api/zerodha/postback`}>
                          <Button type="Button" className="btn btn-sm btn-primary">{copySuccess}</Button>
                        </CopyToClipboard>

                      </p>
                    )}

                    {data.type == 'icici' && (
                      <p><label>Callback URL:</label>
                        <span>https://trade-api.fnotrader.com/v1/callback/icici/{Base64.encode(data.userName)}</span>
                        <CopyToClipboard text={`https://trade-api.fnotrader.com/v1/callback/icici/${Base64.encode(data.userName)}`}>
                          <Button type="Button" className="btn btn-sm btn-primary">{copySuccess}</Button>
                        </CopyToClipboard>
                      </p>
                    )}
                  </div>

                </div>
              }}
            />
          )}
        </Col>
      </div>


      <div className="mb-2">
        <div className=" mt-1 ">
          <div style={{ marginTop: "1.5rem" }} className="important-note">
            <h5 style={{ marginBottom: "0.75rem" }}>Important Notes</h5>
            <ul>
              <li>Once your account is opened successfully through our link, please reach us on whatsapp to enable free access to all our QuikTrade products.</li>
              <li>We support all brokers using Symphony XTS API (Retail / PRO) </li>
              <li>For new broker integration, kindly send an email to <a href="mailto:support@fnotrader.com">support@fnotrader.com.</a>  </li>
            </ul>
          </div>
        </div>
        <div className=" mt-1">
          <Card.Body>


          </Card.Body>
        </div>
      </div>
      <StaticPopup
        message={!loginStatus?.activeTradeSubscription ? ["You do not have valid plan for QuikTrade. Please purchase plan to continue."] : !loginStatus?.brokerLoggedIn ? ['Please login with a broker to use QuikTrade'] : ['Only "Logged In" Zerodha Accounts are available for Broker Trading.', 'Other Broker Logins are enabled for Paper Trading only.']}
        title={!loginStatus?.activeTradeSubscription ? "Purchase QuikTrade Plan" : !loginStatus?.brokerLoggedIn ? "QuikTrade" : "QuikTrade Information"}
        isShow={QuikTradePopup}
        link={!loginStatus?.activeTradeSubscription ? "/quiktrade/pricing" : QuikTradeUrl}
        btnText_1={!loginStatus?.activeTradeSubscription ? "Buy Plan" : !loginStatus?.brokerLoggedIn ? "" : "Launch QuikTrade"}
        btnText_2={!loginStatus?.brokerLoggedIn ? "Ok" : "Cancel"}
        page={!loginStatus?.activeTradeSubscription ? "/quiktrade/pricing" : "trading/broker-accounts"}
        handleClosePopup={() => { handleClosePopup() }}

      />

      <Modal
        title="Authentication"
        open={showPopup}
        onCancel={() => handleClosePopup()}
        footer={null}
        centered
        width={450}
        className="broker-auth-modal"
      >
        <div>
          <form onSubmit={onSubmit} autoComplete="off">
            {ShoonyaData.collectTOTPForLogin && (
              <div className="mb-4">
                <label className="text-black mb-2 fw-semibold">
                  {ShoonyaData.type === 'firstock' ? 'App Code (From the App)' : 'TOTP (From the App)'}
                  <span className="text-danger ms-1">*</span>
                </label>
                <Input
                  size="large"
                  placeholder={ShoonyaData.type === 'firstock' ? "Enter App Code" : "Enter TOTP"}
                  name="shoonyaTotp"
                  value={shoonyaTotp}
                  onChange={onChange}
                  autoComplete="off"
                  suffix={
                    <span>
                      {shoonyaTotp && <i className="fa-solid fa-circle-check text-success"></i>}
                    </span>
                  }
                />
              </div>
            )}
            {ShoonyaData.collectPasswordForLogin && (
              <div className="mb-4">
                <label className="text-black mb-2 fw-semibold">
                  Password <span className="text-danger ms-1">*</span>
                </label>
                <Input.Password
                  size="large"
                  placeholder="Enter Password"
                  name="shoonyaPwd"
                  value={shoonyaPwd}
                  onChange={onChange}
                  autoComplete="new-password"
                  suffix={
                    <span>
                      {shoonyaPwd && <i className="fa-solid fa-circle-check text-success"></i>}
                    </span>
                  }
                />
              </div>
            )}
            <div className="d-flex justify-content-end gap-2 mt-4">
              <AntButton
                onClick={() => handleClosePopup()}
              >
                Cancel
              </AntButton>
              <AntButton
                type="primary"
                htmlType="submit"
                disabled={!shoonyaPwd && !shoonyaTotp}
              >
                Save
              </AntButton>
            </div>
          </form>
        </div>
      </Modal>
      <BrokerLimitModal
        open={showBrokerLimitModal}
        allowedCount={allowedBrokerCount}
        onClose={() => setShowBrokerLimitModal(false)}
      />

      <Modal
        title="Static IP Warning"
        open={showIpWarningModal}
        onCancel={() => setShowIpWarningModal(false)}
        centered
        footer={[
          <AntButton
            key="assign"
            onClick={() => {
              setShowIpWarningModal(false);
              setActiveTab && setActiveTab('static-ip');
            }}
          >
            Assign Static IP
          </AntButton>,
          <AntButton
            key="continue"
            type="primary"
            onClick={() => {
              setShowIpWarningModal(false);
              processEnableTrading(ipWarningModalBroker);
            }}
          >
            Continue
          </AntButton>
        ]}
      >
        <p>Static IP is not assigned to this broker account. Trades may fail at the broker end.</p>
      </Modal>

    </div>
  );
};

export default BrokerAccounts;